import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { colors } from '@theme/colors';

// Lazy load all feature pages
const PortalPage = lazy(() => import('@features/portal/PortalPage'));
const ReequilibrioPage = lazy(() => import('@features/reequilibrio/ReequilibrioPage'));
const CronogramaPage = lazy(() => import('@features/cronograma/CronogramaPage'));
const DisrupcaoPage = lazy(() => import('@features/disrupcao/DisrupcaoPage'));
const TrimestralPage = lazy(() => import('@features/disrupcao/TrimestralPage'));
const TippingPointPage = lazy(() => import('@features/disrupcao/TippingPointPage'));
const RQDPage = lazy(() => import('@features/geologia/RQDPage'));
const PerfuracaoPage = lazy(() => import('@features/geologia/PerfuracaoPage'));
const PerfilInterativoPage = lazy(() => import('@features/geologia/PerfilInterativoPage'));
const ProdutividadePage = lazy(() => import('@features/produtividade/ProdutividadePage'));
const AtasPage = lazy(() => import('@features/atas/AtasPage'));
const FundacoesPage = lazy(() => import('@features/fundacoes/FundacoesPage'));
const RelatorioV4Page = lazy(() => import('@features/relatorios/RelatorioV4Page'));
const RelatorioV5Page = lazy(() => import('@features/relatorios/RelatorioV5Page'));
const FinanceiroPage = lazy(() => import('@features/financeiro/FinanceiroPage'));
const TerraplengemPage = lazy(() => import('@features/financeiro/TerraplengemPage'));

// Loading component
function PageLoader() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          border: `4px solid ${colors.neutral.gray200}`,
          borderTopColor: colors.brand.laranjaManta,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <p style={{ color: colors.neutral.gray500, fontSize: '0.9rem' }}>Carregando...</p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Portal */}
        <Route path="/" element={<PortalPage />} />

        {/* Reequilíbrio */}
        <Route path="/reequilibrio" element={<ReequilibrioPage />} />

        {/* Cronograma */}
        <Route path="/cronograma" element={<CronogramaPage />} />

        {/* Disrupção */}
        <Route path="/disrupcao" element={<DisrupcaoPage />} />
        <Route path="/disrupcao/trimestral" element={<TrimestralPage />} />
        <Route path="/disrupcao/tipping" element={<TippingPointPage />} />

        {/* Geologia */}
        <Route path="/geologia" element={<RQDPage />} />
        <Route path="/geologia/perfuracao" element={<PerfuracaoPage />} />
        <Route path="/geologia/perfil" element={<PerfilInterativoPage />} />

        {/* Produtividade */}
        <Route path="/produtividade" element={<ProdutividadePage />} />

        {/* Atas */}
        <Route path="/atas" element={<AtasPage />} />

        {/* Fundações */}
        <Route path="/fundacoes" element={<FundacoesPage />} />

        {/* Relatórios */}
        <Route path="/relatorios/v4" element={<RelatorioV4Page />} />
        <Route path="/relatorios/v5" element={<RelatorioV5Page />} />

        {/* Financeiro */}
        <Route path="/financeiro" element={<FinanceiroPage />} />
        <Route path="/terraplenagem" element={<TerraplengemPage />} />

        {/* 404 */}
        <Route
          path="*"
          element={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50vh',
                flexDirection: 'column',
                gap: 16,
              }}
            >
              <h1 style={{ color: colors.brand.marromEscuro, fontSize: '3rem' }}>404</h1>
              <p style={{ color: colors.neutral.gray600 }}>Página não encontrada</p>
            </div>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
